module.exports = __webpack_public_path__ + "static/media/Logo-BBVA.2045bc42.svg";